import * as React from 'react'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import DeleteIcon from '@material-ui/icons/Delete'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import { Fetch } from '../Fetch'
import { FetchResult } from '../Fetch'
import DeleteKey from './DeleteKey'
import CreateKey from './CreateKey'


import { Key } from '../../definitions/Key'


const styles = (theme: any) => ({
  noKeys: {
    margin: '10px'
  },
  button: {
    marginLeft: '5px',
    marginTop: '5px',
    marginRight: '5px'
  }
})

export interface ApiKeysManagerProps {
  apiId: string
  classes: any
}

export interface ApiKeysManagerState {
  anchorEl: any
  key: Key
  openDelete: boolean
  openCreate: boolean
}

class ApiKeysManager extends React.Component<ApiKeysManagerProps, ApiKeysManagerState> {

  anchorEl: any

  constructor(props: ApiKeysManagerProps) {
    super(props)
    this.state = {
      anchorEl: null,
      key: null,
      openDelete: false,
      openCreate: false
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.onCloseDelete = this.onCloseDelete.bind(this)
    this.onCloseCreate = this.onCloseCreate.bind(this)
    this.reload = this.reload.bind(this)
  }

  handleClick = (event: any) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  handleDelete(key: Key): void {
    this.setState({
      key: key,
      openDelete: true
    })
  }

  handleCreate(): void {
    this.setState({
      openCreate: true
    })
  }

  onCloseDelete(): void {
    this.handleClose()
    this.setState({
      openDelete: false
    })
  }

  onCloseCreate(): void {
    this.handleClose()
    this.setState({
      openCreate: false
    })
  }

  listKeys(keys: Key[]): JSX.Element[] {
    return keys.map((apiKey: Key) =>
      <TableRow key={apiKey.id}>
        <TableCell>
          {apiKey.name}
        </TableCell>
        <TableCell>
          {apiKey.value}
        </TableCell>
        <TableCell>
          <IconButton onClick={() => this.handleDelete(apiKey)} aria-label="Delete">
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    )
  }

  errorComponent(error: Error) {
    console.error(error)
    return <div>Error: could not fetch</div>
  }

  /**
   * Hack to force menu repositioning
   */
  reload(): void {
    const anchorEl = this.state.anchorEl
    this.setState({
      anchorEl: null
    })
    this.setState({
      anchorEl: anchorEl
    })
  }

  render() {
    const { anchorEl } = this.state
    const { classes } = this.props

    return (
      <div>
        <DeleteKey
          open={this.state.openDelete}
          onClose={this.onCloseDelete}
          apiId={this.props.apiId}
          keyId={this.state.key ? this.state.key.id : ''}
          keyName={this.state.key ? this.state.key.name : ''}
          userId={sessionStorage.getItem('userId')} />

        <CreateKey
          open={this.state.openCreate}
          onClose={this.onCloseCreate}
          apiId={this.props.apiId}
          userId={sessionStorage.getItem('userId')} />

        <Button
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          variant="contained"
          size="medium"
          color="secondary">
          Show keys
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}>
          <Fetch resource='Keys' apiId={this.props.apiId} userId={sessionStorage.getItem('userId')} onLoaded={this.reload}>
            {
              ({ error, result, loading }: FetchResult): JSX.Element => {
                if (error) {
                  return this.errorComponent(error)
                }
                else if (!loading) {
                  if (result.length === 0) {
                    return (
                      <div className={classes.noKeys}>
                        <Typography>No API keys for this API</Typography>
                      </div>
                    )
                  }
                  return (
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Value</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.listKeys(result)}
                        </TableBody>
                      </Table>
                    </div>
                  )
                }
              }
            }
          </Fetch>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={this.handleCreate}>
            Create key
            </Button>
        </Menu>
      </div>
    )
  }
}

export default withStyles(styles)(ApiKeysManager)
